const ADD_TO_FAVOURITE = 'ADD_TO_FAVOURITE';
const VIEW_TECHPACK = 'VIEW_TECHPACK';
const UPDATE_SAMPLE_ID = 'UPDATE_SAMPLE_ID';
const GET_SEARCH_RESULT = 'GET_SEARCH_RESULT';
const SELECTED_SEARCH_TYPE = 'SELECTED_SEARCH_TYPE';
const REMOVE_SEARCH_RESULT = 'REMOVE_SEARCH_RESULT';
const IS_FOCUS_ON_MODAL_CLOSE = 'IS_FOCUS_ON_MODAL_CLOSE';
const IS_EDIT_PRESENTATION = 'IS_EDIT_PRESENTATION';
const IS_TECHPACK_OPEN = 'IS_TECHPACK_OPEN';
const UPDATED_ARCHIVED_PRODUCT_ID = 'UPDATED_ARCHIVED_PRODUCT_ID';

export {
	ADD_TO_FAVOURITE,
	VIEW_TECHPACK,
	UPDATE_SAMPLE_ID,
	GET_SEARCH_RESULT,
	SELECTED_SEARCH_TYPE,
	REMOVE_SEARCH_RESULT,
	IS_FOCUS_ON_MODAL_CLOSE,
	IS_EDIT_PRESENTATION,
	IS_TECHPACK_OPEN,
	UPDATED_ARCHIVED_PRODUCT_ID
};
